'use client'

import { useGSAPContext } from '@/hooks/use-gsap'
import { useStoreI18n } from '@/store'
import { NoResults } from '@/ui/components'
import { gsap } from '@gsap'
import { memo, useRef } from 'react'

interface Props {
  store: any
}

const SpotSanityError = ({ store, ...props }: Props) => {
  const D = useStoreI18n.use.dictionary()
  const comp = useRef<React.RefObject<HTMLDivElement>>(null)
  const tl = useRef<GSAPTimeline | null>(null)

  //Stores
  const handleReset = () => {
    store.reset()
  }

  useGSAPContext({
    scope: comp,
    callback() {
      if (!comp.current) {
        return
      }

      tl.current = gsap.timeline().from(comp.current, {
        opacity: 0,
        y: 20,
        duration: 0.5,
        ease: 'power2.inOut'
      })
    }
  })

  return (
    <NoResults
      title={D['fe.events.error.title']}
      description={D['fe.events.error.description']}
      button={{
        nextLink: false,
        as: 'div',
        onClick: () => handleReset(),
        icon: 'material-symbols:close',
        iconPosition: 'left',
        size: 'l',
        label: D['fe.events.filter.clear']
      }}
      ref={comp as any}
      {...props}
    />
  )
}

export default memo(SpotSanityError)
